import type useAuth from "@/hooks/useAuth"

type AuthUser = ReturnType<typeof useAuth>["user"] | null

/**
 * Check if user should see the water taxi calendar link.
 */
export function canViewWaterTaxi(user: AuthUser): boolean {
  if (!user) return false
  const role = String(user.role ?? "").toLowerCase()
  return (
    role === "taxi_staff" ||
    role === "dock_staff" ||
    role === "manager" ||
    role === "superuser" ||
    role === "admin" ||
    !!user.is_superuser
  )
}

/**
 * Determine whether the current user may view the kitchen calendar.
 */
export function canViewKitchen(user: AuthUser): boolean {
  if (!user) return false
  const role = String(user.role ?? "").toLowerCase()
  const department = String(user.department ?? "").toLowerCase()
  return (
    role === "kitchen_staff" ||
    role === "manager" ||
    role === "superuser" ||
    role === "admin" ||
    role === "staff" ||
    department === "kitchen" ||
    !!user.is_superuser
  )
}

/**
 * Check if user should see the kayak calendar link.
 */
export function canViewKayak(user: AuthUser): boolean {
  if (!user) return false
  const role = String(user.role ?? "").toLowerCase()
  return (
    role === "dock_staff" ||
    role === "manager" ||
    role === "superuser" ||
    role === "admin" ||
    !!user.is_superuser
  )
}
